import { render, staticRenderFns } from "./activeAccount.vue?vue&type=template&id=049d41f2&scoped=true&"
import script from "./activeAccount.vue?vue&type=script&lang=js&"
export * from "./activeAccount.vue?vue&type=script&lang=js&"
import style0 from "./activeAccount.vue?vue&type=style&index=0&id=049d41f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d41f2",
  null
  
)

export default component.exports